import type { ReactNode } from 'react';

interface Props {
  icon: ReactNode;
  title: string;
  description: string;
  action?: ReactNode;
}

export function EmptyState({ icon, title, description, action }: Props) {
  return (
    <div className="flex flex-col items-center justify-center gap-3 py-16 text-center">
      <div className="text-muted-foreground/50 [&_svg]:size-10">{icon}</div>
      <p className="font-medium">{title}</p>
      {/* break-words: a descrição às vezes carrega o termo digitado pelo
          usuário, e uma sequência longa sem espaço vazava do max-w. */}
      <p className="text-muted-foreground max-w-xs text-sm break-words">{description}</p>
      {action}
    </div>
  );
}
